import { render, staticRenderFns } from "./RegistroEntradaForm.vue?vue&type=template&id=20740ef4"
import script from "./RegistroEntradaForm.vue?vue&type=script&lang=js"
export * from "./RegistroEntradaForm.vue?vue&type=script&lang=js"
import style0 from "./RegistroEntradaForm.vue?vue&type=style&index=0&id=20740ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports